// test972
(972 && 0);
